import { render, staticRenderFns } from "./Edit.vue?vue&type=template&id=52770be7&scoped=true&"
import script from "./Edit.vue?vue&type=script&lang=js&"
export * from "./Edit.vue?vue&type=script&lang=js&"
import style0 from "./Edit.vue?vue&type=style&index=0&id=52770be7&lang=scss&"
import style1 from "./Edit.vue?vue&type=style&index=1&id=52770be7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52770be7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52770be7')) {
      api.createRecord('52770be7', component.options)
    } else {
      api.reload('52770be7', component.options)
    }
    module.hot.accept("./Edit.vue?vue&type=template&id=52770be7&scoped=true&", function () {
      api.rerender('52770be7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/purchaseinvoice/Edit.vue"
export default component.exports